// Medidas compartidas por el layout. Estaban repetidas en cada styles.js y
// cambiarlas obligaba a tocar ocho ficheros sin olvidarse de ninguno.
export const SIDEBAR_W = "256px";
